import { ApiService } from './../../services/api/api.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { SubSink } from 'subsink';
import { PublicApiService } from 'src/app/services/public/public-api.service';
import { Subject } from 'rxjs';
@Component({
  selector: 'app-account-videos',
  templateUrl: './account-videos.page.html',
  styleUrls: ['./account-videos.page.scss'],
})
export class AccountVideosPage implements OnInit {
  filter: string = 'all';
  bucket_url = environment.s3_bucket_url;
  subscription = new SubSink();
  data = [];
  paymentHandler: any = null;
  user_videos: any = [];
  user: any = {};
  user_id: string = '';
  logged_user_id: string = '';

  public userLoggedIn: boolean = false;

  constructor(
    private publicService: PublicApiService,
    private router: Router,
    private route: ActivatedRoute,
    private apiService: ApiService,
  ) {
    if(localStorage.getItem("user_data")){
      this.userLoggedIn = true;
      this.logged_user_id = JSON.parse(localStorage.getItem("user_profile")).id
    }
  }

  ngOnInit() {}

  async ionViewWillEnter(){
    this.invokeStripe();
    await this.getAccountVideos();
  }

  VideoFilter(event){
    this.filter = event.target.value;
  }

  getAccountVideos(){
    this.user_videos = [];
    let userId = atob(this.route.snapshot.paramMap.get('userId')!);
    this.user_id = userId;
    // console.log("user status", this.userLoggedIn);
    if(this.userLoggedIn){
      this.subscription.sink = this.apiService.get('users/getUserUploadedVideos/'+userId).subscribe(
        (res: any[]) => {
          this.data = (res['data'] && res['data'][0] && res['data'][0].userVideos) ? res['data'][0].userVideos : [];
          this.user = (res['data'] && res['data'][0]) ? res['data'][0] : [];
          let videos = res['videos'];
          videos.forEach(element => {
            this.user_videos.push(element.video_id);
          });
          // console.log("data", this.data);
          // console.log("videos ", this.user_videos);
        },
        (error) => console.log(error)
      );
    }else{
      this.subscription.sink = this.publicService.get('users/getUserAllVideos/'+userId).subscribe(
        (res: any[]) => {
          this.data = (res['data'] && res['data'][0] && res['data'][0].userVideos) ? res['data'][0].userVideos : [];
          this.user = (res['data'] && res['data'][0]) ? res['data'][0] : [];
          let videos = res['videos'];
          videos.forEach(element => {
            this.user_videos.push(element.video_id);
          });
          // console.log("data", this.data);
          // console.log("videos ", this.user_videos);
        },
        (error) => console.log(error)
      );
    }
  }


  /*------------------------------------------
  --------------------------------------------
  makePayment() Function
  --------------------------------------------
  --------------------------------------------*/
  makePayment(amount: any, video_id) {
    let myThis = this;
    const paymentHandler = (<any>window).StripeCheckout.configure({
      key: environment.stripe_key,
      locale: 'auto',
      token: function (stripeToken: any) {
        let data = {
          amount: amount,
          token: stripeToken.id,
          video_id: video_id,
          receiver_id: atob(myThis.route.snapshot.paramMap.get('userId')!),
          email: stripeToken.email,
        }
        console.log("makePayment", stripeToken);
        myThis.apiService.post('checkout', data).subscribe((res) => {
          myThis.apiService.post('checkout/user-videos', data).subscribe((resp) => {
            console.log("response from server is", resp);
            // console.log("Payment Done")
            myThis.user_videos.push(video_id);
          });
        });

      },
    });

    paymentHandler.open({
      name: 'Local & Live',
      description: 'Stripe Payment',
      amount: amount * 100,
      closed: function(){
        console.log("popup of stripe checkout closed.")
      },
    });
  }

  /*------------------------------------------
  --------------------------------------------
  invokeStripe() Function
  --------------------------------------------
  --------------------------------------------*/
  invokeStripe() {
    console.log("invoke strip");
    if (!window.document.getElementById('stripe-script')) {
      console.log("create strip script");
      const script = window.document.createElement('script');

      script.id = 'stripe-script';
      script.type = 'text/javascript';
      script.src = 'https://checkout.stripe.com/checkout.js';
      script.onload = () => {
        this.paymentHandler = (<any>window).StripeCheckout.configure({
          key: environment.stripe_key,
          locale: 'auto',
          token: function (obj: any) {
            console.log("invokeStripe", obj);
            // alert('Payment has been successfully!');
          },
        });
      };

      window.document.body.appendChild(script);
      console.log("append strip script in body");
    }
  }
  addVideoStats(video_id){
    console.log("User video stats on download");
    if(localStorage.getItem("user_data")){
      console.log("User video stats on download");
      let data = {
        video_id: video_id,
        is_downloaded: true
      }
      this.apiService.post('users/addVideoStats', data).subscribe((res) => {
        console.log("response ======>", res);
      });
    }
  }

  videoDetailPage(video_id){
    this.router.navigate(['/video-detail/'+btoa(video_id) ]);
  }


}
